import script from "./Platform.vue?vue&type=script&setup=true&lang=js"
export * from "./Platform.vue?vue&type=script&setup=true&lang=js"

import "./Platform.vue?vue&type=style&index=0&id=1bd661b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bd661b2"]])

export default __exports__